import {assignInlineVars} from '@vanilla-extract/dynamic';

import {Text} from '#component/base';
import {PageContent} from '#constant/tallyExplorer';
import {sprinkles} from '#style/sprinkles';

import * as css from './PageContent.css';

export const renderFormattedContent = (contents?: PageContent[]): React.ReactNode[] => {
  const contentItems: React.ReactNode[] = [];

  (contents || []).forEach((content, index) => {
    if (content.type === 'formattedText') {
      contentItems.push(
        <div key={index} className={css.formattedContent}>
          {content.content}
        </div>,
      );
    } else if (content.type === 'list') {
      const listItems = (content.items || []).map((item, itemIndex) => {
        return (
          <div key={itemIndex} className={css.listItem}>
            <div
              className={css.listItemImage}
              style={assignInlineVars({
                [css.listItemImageUrl]: `url(${item.imageUrl})`,
              })}
            />
            <div className={sprinkles({flex: 'flex', dir: 'col', gap: [16, 32, 32]})}>
              <Text variant="bodyLarge" color="deepBurgundy">
                {item.title}
              </Text>
              <div className={css.formattedContent}>{item.content}</div>
            </div>
          </div>
        );
      });

      contentItems.push(
        <div key={index} className={css.listItems}>
          {listItems}
        </div>,
      );
    }
  });

  return contentItems;
};
